import React from 'react';
import classnames from 'classnames';
import stylesheet from './DataChip.scss';

const DataChip = ({ label, value, size = '' }) => {
  const dataChipLabelClasses = classnames(stylesheet['data-chip__value'], {
    [stylesheet[`data-chip__value--${size}`]]: size,
  });
  return (
    <div>
      <div className={stylesheet['data-chip__label']}>{label}</div>
      <div className={dataChipLabelClasses}>{value}</div>
    </div>
  );
};

export default DataChip;
